import {randomInt} from '@/helpers/random.js'
import {ref, onUnmounted} from 'vue'

/**
 * Simulated typing composable
 */
export function useSimulatedTyping(source) {

  //Refs
  const isTyping = ref(false)
  const typedOutput = ref('')
  const timer = ref(null)

  //Start typing (cancel any in-flight run first so character chains can't stack)
  const startTyping = () => {
    clearTimeout(timer.value)
    isTyping.value = true
    typedOutput.value = ''
    typeNext()
  }

  //Type next character
  const typeNext = () => {
    if (typedOutput.value.length < source.value.length) {
      timer.value = setTimeout(() => {
        typedOutput.value += source.value[typedOutput.value.length]
        typeNext()
      }, randomInt(5, 10))
    }
    else {
      isTyping.value = false
    }
  }

  //Cancel any pending character timer when the host component unmounts
  onUnmounted(() => clearTimeout(timer.value))

  //Expose interface
  return {
    isTyping,
    typedOutput,
    startTyping,
  }
}
